/**
 * Utility functions for consistent error handling across the application
 */

export const extractErrorMessage = (error: any, fallbackMessage = 'An unexpected error occurred'): string => {
  // Check for axios error response structure
  if (error?.response?.data) {
    // FastAPI typically returns 'detail' field
    if (error.response.data.detail) {
      return error.response.data.detail;
    }
    // Fallback to 'message' field
    if (error.response.data.message) {
      return error.response.data.message;
    }
    // Handle validation errors (array of error objects)
    if (Array.isArray(error.response.data) && error.response.data.length > 0) {
      return error.response.data.map((err: any) => err.msg || err.message || JSON.stringify(err)).join(', ');
    }
    // Handle validation errors with detail array (FastAPI format)
    if (Array.isArray(error.response.data.detail) && error.response.data.detail.length > 0) {
      return error.response.data.detail.map((err: any) => err.msg || err.message || JSON.stringify(err)).join(', ');
    }
  }
  
  // Direct error message
  if (error?.message) {
    return error.message;
  }
  
  // String error
  if (typeof error === 'string') {
    return error;
  }
  
  return fallbackMessage;
};

export const logError = (context: string, error: any, additionalData?: any) => {
  console.error(`[${context}] Error:`, error);
  if (error?.response) {
    console.error(`[${context}] Response status:`, error.response.status);
    console.error(`[${context}] Response data:`, error.response.data);
  }
  if (additionalData) {
    console.error(`[${context}] Additional data:`, additionalData);
  }
};